import { render, staticRenderFns } from "./SPIFRPDF.vue?vue&type=template&id=893b30c0"
import script from "./SPIFRPDF.vue?vue&type=script&lang=js"
export * from "./SPIFRPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports